import {
  InstructionsGeneral,
  KeyboardIcon,
  MenuIcon,
  NavigationMenu,
  PrintConnectIcon,
  PrintDisconnectIcon
} from '@justomx/atlas-design-system'
import { useTranslation } from 'react-i18next'

import LoaderAtom from 'components/atoms/Loader.atom'
import { PageContentAtom } from 'components/atoms/PageContent.atom'
import { StackAtom } from 'components/atoms/Stack.atom'
import { NoDataMolecule } from 'components/molecule/NoData.molecule'
import { ScannerMolecule } from 'components/molecule/Scanner.molecule'
import { InputDialogOrganism } from 'components/organisms/InputDialog.organism'
import { TransferCard } from 'components/organisms/TransferCard.organism'
import { useSessionData } from 'hooks/session.hook'
import { useAssembly } from './Assembly.hook'

const Assembly = () => {
  const { t } = useTranslation('global')
  const { user, country, warehouse, logout } = useSessionData()
  const { dialogRef, actions, transfers, loading, printerReady } = useAssembly()
  const noData = !transfers.length

  return (
    <>
      {loading && <LoaderAtom>Cargando</LoaderAtom>}

      <NavigationMenu
        leftIcon={<MenuIcon />}
        text={t('assembly.title')}
        country={country}
        userEmail={user.username}
        userName={user.firstName}
        version="13.0.1"
        warehouseName={warehouse?.coreDescription || 'Pruebas'}
        menuItems={user.menuItems || []}
        onLogout={logout}
        primaryIcon={<KeyboardIcon />}
        onPrimaryIconClick={actions.handleClickKeyboard}
        secondaryIcon={
          printerReady ? <PrintConnectIcon /> : <PrintDisconnectIcon />
        }
        onSecondaryIconClick={actions.onClickPrinter}
      />

      <PageContentAtom>
        <StackAtom $gap={noData ? 70 : 24} $direction="column">
          <InstructionsGeneral
            title="Instrucciones"
            textLines={[
              'Para iniciar un nuevo armado, escanea una tarima.',
              'Para reanudar, selecciona la ST.'
            ]}
          />

          <StackAtom $direction="column" $gap={16}>
            {transfers.map((transfer) => (
              <TransferCard
                key={transfer.transferId}
                {...transfer}
                onClick={() => {
                  actions.handleClickTransfer(
                    transfer.transferId,
                    transfer.docNum,
                    transfer.status,
                    transfer.warehouse
                  )
                }}
              />
            ))}
          </StackAtom>

          {noData && <NoDataMolecule />}
        </StackAtom>
      </PageContentAtom>

      <ScannerMolecule mode="hidden" onScan={actions.handleScanPallet} />
      <InputDialogOrganism
        dialogRef={dialogRef}
        title="Tarima"
        textboxLabel="Escribe el LPN de la tarima"
        confirmLabel="Continuar"
        cancelLabel="Cancelar"
        confirmAction={actions.handleScanPallet}
      />
    </>
  )
}

export default Assembly
